import { useState } from "react";
import { createPortal } from "react-dom";
import { getConfigISO } from "../../../../../utils/helper";
import { fetchWarehouseAggregate } from "../../../../../utils/LOGIE_API";
import { Button, Tooltip } from "../../../../UI";
import Message from "../../Message";

const AutomaticAggregationButton = ({
  config,
  setLoading,
  editableLayer,
  queryLayer,
  openSnackbar,
  t,
}) => {
  const [showMessage, setShowMessage] = useState(false);

  const handleCalculateWarehouseAggregate = async () => {
    const iso3List = getConfigISO(config);
    const layerConfigId = editableLayer.layerConfig?.id;

    setShowMessage(false);
    if (!layerConfigId || iso3List.length === 0) {
      console.log("Missing layerConfigId or iso3List");
      return;
    }
    setLoading(true);
    const data = await fetchWarehouseAggregate({
      layerId: layerConfigId,
      iso3: iso3List,
    });

    if (data && data.status === "success") {
      editableLayer.refresh();
      queryLayer();
    } else {
      openSnackbar(t("screen.message.error"));
    }
    setLoading(false);
  };

  return (
    <>
      {showMessage &&
        typeof window !== "undefined" &&
        document.getElementById("editor-message-overlay") &&
        createPortal(
          <Message
            title={t("screen.widget.Editor.manager.messages.warehouse.title")}
            subtitle={t(
              "screen.widget.Editor.manager.messages.warehouse.subtitle"
            )}
            onSubmit={handleCalculateWarehouseAggregate}
            onCancel={() => {
              setShowMessage(false);
            }}
            position="absolute"
          />,
          document.getElementById("editor-message-overlay")
        )}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          paddingBottom: 8,
          paddingTop: 8,
          borderTop: "1px solid #eee",
          position: "absolute",
          left: 0,
          background: "var(--elementBackgroundTransparent)",
          backdropFilter: "blur(5px)",
          top: 52,
          zIndex: 1,
          width: "100%",
        }}
      >
        <Button
          isNew
          style={{ position: "relative" }}
          onClick={() => {
            setShowMessage(true);
          }}
        >
          <Tooltip
            content={t(
              "screen.widget.Editor.manager.adminLayerButton.information"
            )}
            showOnHover
            absolute
          />
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 24 24"
            height="22"
            width="22"
            xmlns="http://www.w3.org/2000/svg"
            style={{ marginRight: 4 }}
          >
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M12 4c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8m0-2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 6H9v8h2V8zm6 4-5-4v8l5-4z"></path>
          </svg>
          {t("screen.widget.Editor.manager.adminLayerButton.title")}
        </Button>
      </div>
    </>
  );
};

export default AutomaticAggregationButton;
